<template>
  <div class="AndroidImport">
    <label @click="handleClick" class="import-label">Wybierz pliki</label>
    <LyricsImport ref="lyricsImport" class="lyrics-import" :instantImport="$route.query.import" />
  </div>
</template>

<script>
import LyricsImport from '@/views/LyricsImport.vue'
import { getAndroidContext } from '@/services/sessionProps'

export default {
  name: "AndroidImport",
  components: {
    LyricsImport
  },
  data() {
    return {
      isAndroidContext: false
    }
  },
  methods: {
    handleClick() {
      this.$refs.lyricsImport.openExplorer()
    }
  },
  mounted() {
    this.isAndroidContext = getAndroidContext().isAndroidContext()

    setTimeout(() => {
      if(document.querySelector('#chat-application') && this.isAndroidContext) {
        document.querySelector('#chat-application').classList.add('hidden-chat')
      }
    }, 200)
  },
  beforeDestroy() {
    document.querySelector('#chat-application').classList.remove('hidden-chat')
  }
}
</script>

<style scoped lang="scss">
.AndroidImport {
  position: relative;
  height: 100vh;
  width: 100vw;
  .import-label {
    position: absolute;
    display: block;
    width: 80%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    margin: auto;
    padding: 16px 0;
    cursor: pointer;
    border: 1px dashed #b5b5b5;
    color: #b5b5b5;
    text-align: center;
  }
  .lyrics-import {
    visibility: hidden;
  }
}
</style>